import {
  VERIFY_COMPANY_CODE_REQUEST,
  GENERATE_TEMP_PASSWORD_REQUEST,
  LOGIN_TEMP_PASSWORD_REQUEST,
  CHANGE_PASSWORD_REQUEST,
  SETUP_PROFILE_REQUEST,
  CREATE_PASSWORD_REQUEST,
  RESET_ONBOARDING,
} from '../reducers/OnboardingReducer';

export const verifyCompanyCode = (payload) => ({ 
  type: VERIFY_COMPANY_CODE_REQUEST, 
  payload 
});

export const generateTempPassword = (payload, callback) => ({ 
  type: GENERATE_TEMP_PASSWORD_REQUEST, 
  payload,
  callback
});

export const loginTempPassword = (payload, callback) => ({ 
  type: LOGIN_TEMP_PASSWORD_REQUEST, 
  payload,
  callback
});

export const changePassword = (payload) => ({ 
  type: CHANGE_PASSWORD_REQUEST, 
  payload 
});

export const setupProfile = (payload) => ({ 
  type: SETUP_PROFILE_REQUEST, 
  payload 
});

export const createPassword = (payload) => ({ 
  type: CREATE_PASSWORD_REQUEST, 
  payload 
});

export const resetOnboarding = () => ({
  type: RESET_ONBOARDING,
});


